"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-root-class-name/get-root-class-name.ts
/** Adds `className` to the list if given selector is root */
function getRootClassName({ rootSelector, selector, className }) {
	return rootSelector === selector ? className : void 0;
}
//#endregion
export { getRootClassName };

//# sourceMappingURL=get-root-class-name.mjs.map